import $ from 'jquery';

function answerFinderInit() {
    $('a.download-button').click(function () {
        const href = $(this).attr('href');
        const fileData = {
            pageName: $('h2.product-name').html(),
            fileName: href.split('/').pop(),
            fileUrl: href
        };
        $.ajax({
            cache: false,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            url: '/api/PdfDownload/StorePdfDownloadActivity',
            data: fileData
        });
    });
}

$(() => {
    answerFinderInit();
});
